<template>
    <section class="single-area responsive-content area-padding mid-top-padding">
      <div class="service-fluid">
        <div class="container">
          <div class="avivon-heading">
            <h3 class="avivon__title">
              Costos y Comisiones.
            </h3>
            <p class="avivon__desc offer-title2 mb-15px">
              Puedes descargar el archivo de costos y comisiones <a class="" :href="pdfURL" target="_blank" download>aquí</a>.
            </p>
          </div>
          <embed :src="pdfURL" type="application/pdf" width="100%" height="650px" />
        </div><!-- container -->
      </div><!-- end service-fluid -->
    </section>
</template>

<script>
import Accordion from 'accordion-js';
export default {
  name: "CPInvestorAccordion",
  data() {
    return {
      pdfURL: "https://cdn.redgirasol.com/informativos/Folleto-Costos-y-Comisiones-Octubre-2024.pdf"
    }
  },
  mounted(){
    const options = {
      triggerClass: 'ac-q',
      panelClass: 'ac-a',
    }
    new Accordion([".accordion-container1", ".accordion-container2", ".accordion-container3"], options);
  }
}
</script>

<style scoped>

</style>